import { render, staticRenderFns } from "./requisitionview.vue?vue&type=template&id=9de980e0"
import script from "./requisitionview.vue?vue&type=script&lang=js"
export * from "./requisitionview.vue?vue&type=script&lang=js"
import style0 from "./requisitionview.vue?vue&type=style&index=0&id=9de980e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports